import React from 'react';
import styled from 'styled-components';
import { AppColors } from 'helpers';
import { HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { Image } from 'components/common/vendors/Image';
import { useAppSetting } from 'helpers/useAppSetting';
import { IPost } from 'types/types';
import { RecentNewsCard } from './RecentNewsCard';
import { useHistory } from 'react-router';
import { friendlyURL } from 'helpers/commonUtils';
import { Hr } from 'vendor-deprecated/CommonParts';
import { TextDisplay } from 'vendor-deprecated/Text';
import { useTranslationText } from 'locale';

interface RecentNewsProps {
  news: IPost[];
}

export const RecentNews = (props: RecentNewsProps) => {
  const { appSize } = useAppSetting();
  const { translation } = useTranslationText();
  const history = useHistory();

  return (
    <VerticalView width={'360px'} paddingTop={'20px'} paddingLeft={'30px'}>
      <VerticalView fullWidth paddingBottom={'20px'} alignContent={'centerLeft'}>
        <TextDisplay size={appSize.h2} fontWeight={600}>
          {translation('recentNews')}
        </TextDisplay>
      </VerticalView>

      {props.news.map((news, index) => {
        return (
          <RecentNewsCard
            key={index}
            title={news.title || ''}
            time={news.createdTime}
            image={news.thumbnail || ''}
            onClick={() => {
              const seoname = friendlyURL(news.id, news.seoName || 'news');
              history.push(`/articles/${seoname}`);
            }}
          />
        );
      })}
    </VerticalView>
  );
};
